module.exports = __webpack_public_path__ + "static/media/tableGroupOrdering.5fe27c07.png";